import Vue from 'vue';
import Router from 'vue-router';
// import Login from "./views/Login.vue";

Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: "/",
    //   name: "Login",
    //   component: Login
    // },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('./views/Dashboards.vue'),
    },
    {
      path: '/mapvisual',
      name: 'Map',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Map.vue'),
    },
    {
      path: '/',
      name: 'Map2',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/MapView2.vue'),
    },
    {
      path: '/statistics',
      name: 'Statistics',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/StatisticsCard.vue'),
    },
    {
      path: '/modeshare',
      name: 'ModeShare',
      component: () => import('./views/ModeShare.vue'),
    },
    {
      path: '/top5accesstobikes',
      name: 'Top5AccessToBikes',
      component: () => import('./views/Top5AccessToBikes.vue'),
    },
    {
      path: '/cyclerouteinfo',
      name: 'CycleRouteInfo',
      component: () => import('./views/CycleRouteInformation.vue'),
    },
    {
      path: '/top5usualcycling',
      name: 'Top5UsualCycling',
      component: () => import('./views/Top5UsualCycling.vue'),
    },
    {
      path: '/attitudes',
      name: 'Attitudes',
      component: () => import('./views/Attitudes.vue'),
    },
    {
      path: '/safetystatistics',
      name: 'SafetyStatistics',
      component: () => import('./views/SafetyStatistics.vue'),
    },
    {
      path: '/cycletoSchool',
      name: 'CycleToSchool',
      component: () => import('./views/CycleToSchool.vue'),
    },
  ],
});
